import React from 'react';
import PropTypes from 'prop-types';

import { PageLayout } from 'common/components';
import MyBonusesPage from '../MyBonusesPage';

const BonusCommonPage = ({ match }) => (
  <PageLayout captionSlug="menuMyBonuses" extraCaptionText={match.params.id} showReload={false}>
    <MyBonusesPage />
  </PageLayout>
);

BonusCommonPage.propTypes = {
  match: PropTypes.object.isRequired,
};

export default BonusCommonPage;
